import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import { createPinia } from "pinia";
import { createApp } from 'vue';
import App from '~/App.vue';
import '~/assets/styles/main/main.scss';
import '~/assets/styles/vendors/element-plus.scss';
import acl from '~/plugins/acl';
import { i18n } from '~/plugins/i18n';
import { router } from '~/plugins/router';
import { defaultLanguage } from './core/constants/languages';
import { LxcDragNDrop } from './plugins/lxcDragNDrop';

// Import Tailwind CSS
import '@lxc/css/fonts/Montserrat/webfonts/Montserrat.css';
import '@lxc/css/main.css';

// Import common CSS
import '@lxc/app-device-common/dist/assets/index.css';

// Import dragula styles
import 'dragula/dist/dragula.css';

const app = createApp(App)

dayjs.extend(localeData)
dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.locale(defaultLanguage)

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(acl)
app.use(LxcDragNDrop)

app.mount('#app')
